var PageState_1;
import { __decorate, __metadata } from "tslib";
import { inject, DOCUMENT } from '@angular/core';
import { ActivationStart, NavigationStart, Router } from '@angular/router';
import { Action, createSelector, Selector, State, Store } from '@ngxs/store';
import { filter, skip, take } from 'rxjs';
import { PageActions } from './page.actions';
import { parseUrlParams2 } from '@core/shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngxs/store";
let PageState = /*#__PURE__*/(() => {
  let PageState = class PageState {
    static {
      PageState_1 = this;
    }
    static title(state) {
      return state.title;
    }
    static meta(state) {
      return state.meta;
    }
    static isInitialRoute(state) {
      return state.isInitialRoute;
    }
    /** NOTE: param names are converted to lowercase! */
    static initialRouteParams(state) {
      return state.initialRouteParams;
    }
    static get(key) {
      return createSelector([PageState_1], state => {
        return typeof state[key] !== 'undefined' ? state[key] : null;
      });
    }
    constructor(router, store) {
      this.store = store;
      this.document = inject(DOCUMENT);
      router.events.subscribe(event => {
        /**
         * Note: the event may emit multiple times during navigation.
         * We cannot work around that because that is how lazy loaded routes work.
         */
        if (event instanceof ActivationStart) {
          const routeData = event.snapshot.data;
          const title = routeData['pageTitle'] || '';
          this.store.dispatch(new PageActions.SetTitle(title));
          const meta = [];
          if (routeData['metaDescription']) {
            meta.push({
              name: 'description',
              content: routeData['metaDescription']
            });
          }
          if (routeData['metaKeywords']) {
            meta.push({
              name: 'keywords',
              content: routeData['metaKeywords']
            });
          }
          if (routeData['metaRobots']) {
            meta.push({
              name: 'robots',
              content: routeData['metaRobots']
            });
          }
          this.store.dispatch(new PageActions.SetMeta(meta, true));
        }
      });
      router.events.pipe(filter(event => event instanceof NavigationStart), skip(1), take(1)).subscribe(event => {
        this.store.dispatch(new PageActions.SetIsInitialRoute(false));
      });
    }
    ngxsOnInit(ctx) {
      this.collectInitialRouteParams();
    }
    collectInitialRouteParams() {
      const paramsMap = parseUrlParams2(this.document, true);
      this.store.dispatch(new PageActions.SetInitialRouteParams(paramsMap));
    }
    setIsInitialRoute({
      patchState
    }, action) {
      patchState({
        isInitialRoute: action.isInitialRoute
      });
    }
    setInitialRouteParams({
      patchState
    }, action) {
      patchState({
        initialRouteParams: action.params
      });
    }
    setTitle({
      patchState
    }, action) {
      patchState({
        title: action.title
      });
    }
    setMeta({
      getState,
      patchState
    }, {
      data,
      resetMeta
    }) {
      // reset meta will be triggered on route changes to make sure custom meta will not be persisted.
      let newMeta = resetMeta ? [] : [...getState().meta];
      data.forEach(metaInfo => {
        const existingIndex = newMeta.findIndex(exist => exist.name === metaInfo.name);
        if (metaInfo.content === null) {
          // reset entry by removing from custom meta set
          if (existingIndex) {
            newMeta.splice(existingIndex, 1);
          }
        } else if (existingIndex > -1) {
          // update entry
          newMeta[existingIndex] = metaInfo;
        } else {
          // create entry
          newMeta.push(metaInfo);
        }
      });
      patchState({
        meta: newMeta
      });
    }
    static {
      this.ɵfac = function PageState_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PageState)(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.Store));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: PageState,
        factory: PageState.ɵfac
      });
    }
  };
  __decorate([Action(PageActions.SetIsInitialRoute), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, PageActions.SetIsInitialRoute]), __metadata("design:returntype", void 0)], PageState.prototype, "setIsInitialRoute", null);
  __decorate([Action(PageActions.SetInitialRouteParams), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, PageActions.SetInitialRouteParams]), __metadata("design:returntype", void 0)], PageState.prototype, "setInitialRouteParams", null);
  __decorate([Action(PageActions.SetTitle), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, PageActions.SetTitle]), __metadata("design:returntype", void 0)], PageState.prototype, "setTitle", null);
  __decorate([Action(PageActions.SetMeta), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, PageActions.SetMeta]), __metadata("design:returntype", void 0)], PageState.prototype, "setMeta", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], PageState, "title", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], PageState, "meta", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], PageState, "isInitialRoute", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Object)], PageState, "initialRouteParams", null);
  return PageState;
})();
PageState = PageState_1 = __decorate([State({
  name: 'page',
  defaults: {
    title: 'Home',
    meta: [],
    isInitialRoute: true,
    initialRouteParams: null
  }
}), __metadata("design:paramtypes", [Router, Store])], PageState);
export { PageState };